import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Adjust path if necessary

const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    // Redirect to login page with reason=unauthorized
    return <Navigate to="/login?reason=unauthorized" state={{ from: location }} replace />; 
  }

  // Render the nested routes (Outlet) if authenticated
  return <Outlet />;
};

export default ProtectedRoute; 